<template>
  <v-app-bar app flat class="app-bar-shadow">
    <v-app-bar-nav-icon
      class="text-on-primary mx-0"
      @click="useMenuStore().toggleIsNavDrawerVisible()"
    ></v-app-bar-nav-icon>
    <v-toolbar color="white">
      <!-- Search bar here eventually -->
      <v-divider :thickness="10" vertical inset color="primary" class="mx-2 border-opacity-100" />
      <v-row align="center" no-gutters>
        <v-col cols="auto">
          <v-toolbar-title>
            {{ $route.meta.title }}
          </v-toolbar-title>
        </v-col>
        <v-col>
          <v-divider class="mx-3" />
        </v-col>
      </v-row>
      <app-bar-location-selector />
      <v-badge
        v-if="cartStore?.items?.length > 0"
        class="mx-3 pt-1"
        :content="sumQuantities()"
        :model-value="cartStore?.items?.length > 0"
        color="red"
        :class="{ 'badge-pulse': cartStore?.isAnimating }"
      >
        <v-btn
          icon="mdi-cart-outline"
          data-cy="cart"
          class="text-on-primary"
          @click="cartStore.toggleIsCartVisible()"
          :disabled="shouldDisableCart"
        />
      </v-badge>

      <v-btn
        v-else
        icon="mdi-cart-outline"
        data-cy="cart-nobadge"
        class="text-on-primary mx-0 mr-2"
        @click="useCartStore().toggleIsCartVisible()"
        :disabled="shouldDisableCart"
      />

      <v-menu right>
        <template v-slot:activator="{ props }">
          <v-avatar
            class="app-bar-initials-avatar mr-0 pr-0 simple-action-link"
            color="primary"
            size="40"
            v-bind="props"
          >
            <v-icon v-if="!useAuthStore().getAuthInitials" size="large" color="white">
              mdi-account-outline
            </v-icon>
            <div v-if="!!useAuthStore().getAuthInitials">
              {{ useAuthStore().getAuthInitials }}
            </div>
          </v-avatar>
          <v-btn
            variant="plain"
            v-bind="props"
            class="text-none text-start mb-1 mr-10"
            append-icon="mdi-menu-down"
          >
            <v-list-item class="pl-0 pr-0">
              <v-list-item-title>
                {{ useAuthStore().getAuthDisplayName }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-capitalize">
                {{ useAuthStore().getRoleName }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-btn>
        </template>
        <v-list class="pt-0 pr-0" density="comfortable">
          <v-list-item>
            <v-list-item-title>{{ useAuthStore().getAuthDisplayName }}</v-list-item-title>
            <v-list-item-subtitle>{{ useAuthStore().getAuthEmail }}</v-list-item-subtitle>
          </v-list-item>
          <v-divider />
          <v-list-item
            data-test="app-bar-profile-link"
            @click="$router.push({ name: 'userProfile' })"
          >
            <v-list-item-title>{{ $t("page.profile.title") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="useAuthStore().logout()">
            <v-list-item-title>{{ $t("platform.logout") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
  </v-app-bar>
</template>
<script lang="ts" setup>
import { useAuthStore } from "@/auth/stores/auth";
import { useMenuStore } from "@/shared/stores/global";
import { useCartStore } from "@/cart/stores/cart";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { Pages } from "@/shared/enums/route.enum";
import { useDisplay } from "vuetify";
import AppBarLocationSelector from "@/shared/components/AppBarLocationSelector.vue";

const cartStore = useCartStore();
const route = useRoute();
const { mobile } = useDisplay();

const isScannerPage = computed(() => {
  return route.name === Pages.SCANNER;
});

const isMobile = computed(() => {
  return mobile.value;
});

const shouldDisableCart = computed(() => {
  return isScannerPage.value && !isMobile.value;
});

const sumQuantities = () => {
  const items = cartStore.items;
  return items.reduce((total, item) => total + item.quantity, 0);
};
</script>

<style>
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}
.badge-pulse .v-badge__badge {
  animation: pulse 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.app-bar-shadow {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.app-bar-initials-avatar {
  color: #ffffff !important;
  font-weight: 700;
  box-shadow: none !important;
}
</style>
